import { render, staticRenderFns } from "./IntegrationsLayout.vue?vue&type=template&id=d84830bc&scoped=true"
import script from "./IntegrationsLayout.vue?vue&type=script&lang=js"
export * from "./IntegrationsLayout.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsLayout.vue?vue&type=style&index=0&id=d84830bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84830bc",
  null
  
)

export default component.exports